import dayjs from 'dayjs';

import { DATE_FORMAT } from '../custom';
import { isAlertOnAnyDashboard } from '../../../../api-server/alertFilter';
import BarBase from './BarBase';

const SET_APTMT_DATE = 'set-appointment-date';
const EDIT_APTMT_DATE = 'edit-appointment-date';
const TOTAL_COMPLETED = 'Total Completed';
const SCHEDULED_WI_7_DAYS = 'Sched. Within 7 Days';
const NON_ROUTABLE = 'Non-Routable';
const RESCHEDULED = 'Rescheduled';

export default function DetailedChart({ chartData, isClinic }) {
  const data = [];
  const detailedCounts = {};

  const countCompleted = (alertStatus) => {
    if (alertStatus === 3) {
      if (!(TOTAL_COMPLETED in detailedCounts)) {
        detailedCounts[TOTAL_COMPLETED] = {
          label: TOTAL_COMPLETED,
          value: 1,
        };
      } else {
        detailedCounts[TOTAL_COMPLETED].value += 1;
      }
    }
  };

  const countScheduledRescheduled = (alertDate, actions) => {
    // Only count rescheduled max one time
    // for each alert.
    let isRescheduled = false;
    for (const action of actions) {
      if (action.action === SET_APTMT_DATE) {
        const dateCreated = dayjs(alertDate, DATE_FORMAT);
        const dateScheduled = dayjs(action.timestamp, DATE_FORMAT);
        const daysToSchedule = Math.abs(
          dateCreated.diff(dateScheduled, 'days'),
        );
        const isWithin7Days = daysToSchedule <= 7;
        if (isWithin7Days) {
          if (!(SCHEDULED_WI_7_DAYS in detailedCounts)) {
            detailedCounts[SCHEDULED_WI_7_DAYS] = {
              label: SCHEDULED_WI_7_DAYS,
              value: 1,
            };
          } else {
            detailedCounts[SCHEDULED_WI_7_DAYS].value += 1;
          }
        }
      }
      if (action.action === EDIT_APTMT_DATE) {
        isRescheduled = true;
      }
    }
    if (isRescheduled) {
      if (!(RESCHEDULED in detailedCounts)) {
        detailedCounts[RESCHEDULED] = {
          label: RESCHEDULED,
          value: 1,
        };
      } else {
        detailedCounts[RESCHEDULED].value += 1;
      }
    }
  };

  const countNonRoutable = (alertData) => {
    const copiedData = structuredClone(alertData);
    // Don't consider unclaims for this calculation.
    // We want to know how many alerts never
    // saw a clinic dashboard.
    copiedData.unclaimedClinics = [];
    // If the alert filter changes, we'll want
    // to refer back to the version that was
    // used to decide the routing at the time
    // this alert was created.
    const isOnADashboard = isAlertOnAnyDashboard(copiedData);
    if (!isOnADashboard) {
      if (!(NON_ROUTABLE in detailedCounts)) {
        detailedCounts[NON_ROUTABLE] = {
          label: NON_ROUTABLE,
          value: 1,
        };
      } else {
        detailedCounts[NON_ROUTABLE].value += 1;
      }
    }
  };

  for (const alertElement of chartData) {
    const {
      actionHistory: { actions },
      alertStatus,
      alertDate,
    } = alertElement;
    countCompleted(alertStatus);
    countScheduledRescheduled(alertDate, actions);
    !isClinic && countNonRoutable(alertElement);
  }

  for (const detail of Object.values(detailedCounts)) {
    data.push(detail);
  }

  return (
    <BarBase
      title={'Detailed Data'}
      data={data}
      layout={'vertical'}
    />
  );
}
